<template>
    <div class="main Ssdt">
        <div class="title">半壁店村接诉即办案件实时动态</div>

        <div class="cont">
            <div class="info">
                <swiper
                    :options="swiperOption"
                    ref="infoSwiper"
                    style="width: 100%; height: 100%"
                    v-if="ifShowSwiper"
                >
                    <swiper-slide
                        v-for="(item, i) in list"
                        :key="i"
                    >
                        <div class="cbox">
                            <div class="source">
                                <div class="con">上报来源: {{item.reportfromname}}</div>
                            </div>
                            <div class="left">
                                <img
                                    src="../../assets/banbidian/bm.png"
                                    alt=""
                                    class="img"
                                /> {{item.orgname}}
                            </div>
                            <div class="middle">
                                {{item.content}}
                            </div>
                            <div class="time">
                                <span>{{item.starttime}}</span>
                            </div>
                            <div class="right">
                                <div class="fl">
                                    <img
                                        src="../../assets/banbidian/fl.png"
                                        alt=""
                                        class="img"
                                    />
                                    <span class="fenlei">{{item.name}}</span>
                                </div>
                                <div class="circle" :style="`box-shadow: 0 0 30px ${item.color} inset;color:${item.color}`"><span>{{item.state}}</span></div>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>
<script>
import miment from "miment";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            ifShowSwiper: false,
            swiperOption: {
                autoplay: {
                    delay: 3000,
                },
                direction: "vertical",
                speed: 3000,
                slidesPerView: 5,
                slidesPerGroup: 1,
                loop: true,
            },
            list: [],
            timer: 0
        };
    },
    methods: {
        getToken() {
            this.$get(this.urlobj.getMockToken, {
                account: "wangqing",
            }).then((res) => {
                localStorage.token = res.newPrimaryKeys.token;
                this.$store.commit("updateToken", res.newPrimaryKeys.token);
                this.getData();
                this.timer = setInterval(()=>{
                    this.getData();
                },30000)
                
            });
        },
        async getData() {
            var url = this.urlobj.bbd_dp+'?rows=15&page=1';
                console.log('3')
                this.$get(url).then((res) => {
                    this.list = res.map((item) => {
                        let color = "";
                        switch (item.state) {
                            case "待审核":
                                color = "orange";
                                break;
                            case "已办结":
                                color = "green";
                                break;
                            case "已逾期":
                                color = "red";
                                break;
                            case "办理中":
                                color = "yellow";
                                break;
                        }
                        return {
                            ...item,
                            color
                        }
                    })
                    this.ifShowSwiper = true;
                });
                
            
            
        },
    },
    created() {
        this.getToken();
    },
    beforeDestroy() {
        clearTimeout(this.timer)
    }
};
</script>
<style lang="less" scoped>
.main {
    height: 100%;
    width: 100%;
    overflow: hidden;
    background: url("../../assets/banbidian/kuang.png") no-repeat;
    background-size: 100% 100%;
    .title {
        color: #ededed;
        text-align: center;
        font-size: 40px;
        font-weight: 400;
        height: 40px;
        line-height: 40px;
        margin: 36px 0 70px 0;
    }
    .cont {
        height: 750px;
        margin-left: 20px;
        box-sizing: border-box;
        padding: 10px 12px;
        width: 97%;
        text-align: center;
        .info {
            .swiper-slide /deep/ {
                // height: 48px !important;
                // margin: 10px 0;
            }
            height: 750px;
            .cbox {
                height: 126px;
                width: 100%;
                position: relative;
                box-sizing: border-box;
                padding: 35px 0px;
                box-shadow: 0 0 40px #6692e9 inset;
                border-radius: 10px;
                display: flex;
                align-items: center;
                font-size: 20px;
                margin: 0 0 30px 0;
                .source {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 46px;
                    width: 228px;
                    border-radius: 10px 10px 50px 10px;
                    background: #5078cf;
                    .con {
                        // text-align: left;
                        line-height: 46px;
                        color: #fff;
                        font-size: 22px;
                    }
                }
                .left {
                    border-right: 1px solid #6894ed;
                    height: 70px;
                    width: 13%;
                    color: #04bafb;
                    box-sizing: border-box;
                    padding: 30px 0 0 0;
                }
                .middle {
                    width: 71%;
                    color: #fff;
                    text-align: left;
                    box-sizing: border-box;
                    padding: 10px 15px;
                    font-size: 22px;
                    height: 82px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .time {
                    color: #969a9d;
                    text-align: right;
                    position: absolute;
                    bottom: 0;
                    right: 288px;
                    font-size: 20px;
                    span {
                        // position: absolute;
                        // top: -10px;
                        // right: 6px;
                        // height: 20px;
                        // display: inline-block;
                        // z-index: 99;
                    }
                }
                .right {
                    width: 16%;
                    height: 70px;
                    border-left: 1px solid #6894ed;
                    color: #52d1c0;
                    box-sizing: border-box;
                    padding: 4px 20px 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .fl {   
                            width: 140px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            // .fenlei {
                            //     overflow: hidden;
                            //     text-overflow: ellipsis;
                            //     display: -webkit-box;
                            //     -webkit-line-clamp: 3;
                            //     -webkit-box-orient: vertical;
                            // }

                        }
                    .circle {
                        height: 80px;
                        width: 80px;
                        border-radius: 80px;
                        // box-shadow: 0 0 30px green inset;
                        line-height: 80px;
                    }
                }
            }
        }
    }
}
.img {
    margin: 0 4px 0 0;
}
</style>